export const KEY_CODE = {
  ENTER: 13,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  ESC: 27,
  SPACE: 32,
  DELETE: 46,
};

function lower(char) {
  return (char || '').toLowerCase();
}

function reduceText(text, targetText, split) {
  const firstChar = text.slice(0, 1);
  if (!firstChar || firstChar === split) {
    return text;
  }

  let restText = text;
  const targetTextLen = targetText.length;
  for (let i = 0; i < targetTextLen; i += 1) {
    if (lower(restText[i]) !== lower(targetText[i])) {
      restText = restText.slice(i);
      break;
    } else if (i === targetTextLen - 1) {
      restText = restText.slice(targetTextLen);
    }
  }

  return restText;
}

export function getBeforeSelectionText(input) {
  const { selectionStart } = input;
  return input.value.slice(0, selectionStart);
}

export function getLastMeasureIndex(text, prefix) {
  const prefixList = Array.isArray(prefix) ? prefix : [prefix];
  return prefixList.reduce((lastMatch, prefixStr) => {
    const lastIndex = text.lastIndexOf(prefixStr);
    if (lastIndex > lastMatch.location) {
      return {
        location: lastIndex,
        prefix: prefixStr,
      };
    }
    return lastMatch;
  }, { location: -1, prefix: '' });
}

export function replaceWithMeasure(text, measureConfig) {
  const { location, prefix, targetText, selectionStart, split } = measureConfig;

  let beforeMeasureText = text.slice(0, location);
  if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
    beforeMeasureText = beforeMeasureText.slice(0, beforeMeasureText.length - split.length);
  }
  if (beforeMeasureText) {
    beforeMeasureText = `${beforeMeasureText}${split}`;
  }

  let restText = reduceText(
    text.slice(selectionStart),
    targetText.slice(selectionStart - location - prefix.length),
    split
  );
  if (restText.slice(0, split.length) === split) {
    restText = restText.slice(split.length);
  }

  const connectedStartText = `${beforeMeasureText}${prefix}${targetText}${split}`;

  return {
    text: `${connectedStartText}${restText}`,
    selectionLocation: connectedStartText.length,
  };
}

export function setInputSelection(input, location) {
  input.setSelectionRange(location, location);

  input.focus();
}

export function validateSearch(text, { split }) {
  return !split || text.indexOf(split) === -1;
}

export function filterOption(input, { value = '', label = '' }) {
  const matchValue = lower(String(value)).includes(lower(input));
  const matchLabel = lower(String(label)).includes(lower(input));
  return matchValue || matchLabel;
}
